import Swal from "sweetalert2";

export const handle401 = (error) => {
  if (error.response?.status === 401) {
    Swal.fire("Session Expired", "Please login again", "warning");
    localStorage.clear();

    window.location.href = "/ulb/login";

    return true;
  }
  return false;
};
